import { Component, Output, EventEmitter, OnInit, input, signal } from '@angular/core';

import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlarmsService } from '../../services/alarms.service';
import { HelpService } from '/app/services/help/help.service';
import { Alarm, LapseEvaluationClassification } from '../../models/alarm.model';

@Component({
  selector: 'app-alarms-classification-form',
  imports: [ReactiveFormsModule, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './alarms-classification-form.component.html',
  styleUrls: ['./alarms-classification-form.component.scss'],
})
export class AlarmsClassificationFormComponent implements OnInit {
  @Output() classificationComplete = new EventEmitter<{ id: string, status: string }>();
  alarmData = input<any>(null);
  @Output() closed = new EventEmitter<void>();
  classificationForm: FormGroup;
  loading = signal(false);
  successMessage = signal('');
  errorMessage = signal('');



statusOptions = [
  { value: 'Alarma Atrasada', label: 'Alarma Atrasada' },
  { value: 'Alarma Clasificación Automática', label: 'Alarma Clasificación Automática' },
  { value: 'Alarma Verdadero', label: 'Alarma Verdadero' },
  { value: 'Alarma en Falso', label: 'Alarma en Falso' },
  { value: 'Alarmas Pendientes de Trato', label: 'Alarmas Pendientes de Trato' },
  { value: 'Cliente Inactivo', label: 'Cliente Inactivo' },
  { value: 'Cliente a Desinstalar', label: 'Cliente a Desinstalar' },
  { value: 'Cliente en Stand By', label: 'Cliente en Stand By' },
  { value: 'Conductor Fumando', label: 'Conductor Fumando' },
  { value: 'Detección de Cansancio', label: 'Detección de Cansancio' },
  { value: 'Detección de Distracción', label: 'Detección de Distracción' },
  { value: 'Detección de Fatiga', label: 'Detección de Fatiga' },
  { value: 'Detección de Uso de Teléfono', label: 'Detección de Uso de Teléfono' },
  { value: 'En Duda', label: 'En Duda' },
  { value: 'Error de Manipulación', label: 'Error de Manipulación' },
  { value: 'Falsa Alarma con Activación Policial', label: 'Falsa Alarma con Activación Policial' },
  { value: 'Móvil Inactivo', label: 'Móvil Inactivo' },
  { value: 'Móvil Observado', label: 'Móvil Observado' },
  { value: 'Móvil a Desinstalar', label: 'Móvil a Desinstalar' },
  { value: 'Móvil en Base Cliente', label: 'Móvil en Base Cliente' },
  { value: 'Móvil en Centro', label: 'Móvil en Centro' },
  { value: 'Notificado a Contacto', label: 'Notificado a Contacto' },
  { value: 'Otro', label: 'Otro' },
  { value: 'Probable Falla', label: 'Probable Falla' },
  { value: 'Prueba Atención Servicios', label: 'Prueba Atención Servicios' },
  { value: 'Prueba de Servicios', label: 'Prueba de Servicios' },
  { value: 'Sin Contacto', label: 'Sin Contacto' }
];



  constructor(private fb: FormBuilder, private alarmsService: AlarmsService, private helpService: HelpService) {
    this.classificationForm = this.fb.group({
      status: ['', Validators.required],
      observations: [''],
    });
  }

  showHelp(): void {
    this.helpService.startTour(this.helpService.getAlarmClassificationFormHelpSteps());
  }

  ngOnInit() {
    // Inicializar valores del formulario
    this.classificationForm.patchValue({
      status: '',
      observations: ''
    }, { emitEvent: false });

   
    
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj).filter(key => isNaN(Number(key)));
  }

  onSubmit() {
    if (this.classificationForm.valid) {
      this.loading.set(true);
      this.successMessage.set('');
      this.errorMessage.set('');

      const formData: LapseEvaluationClassification = {
        status: this.classificationForm.get('status')?.value,
        observations: this.classificationForm.get('observations')?.value || '',
      };

      // Aquí deberás pasar el id de la alarma según tu lógica
      const alarmId = this.alarmData()?.id;

      this.alarmsService
        .doClassification(formData, alarmId)
        .subscribe({
          next: (alarm: Alarm) => {
            this.loading.set(false);
            this.successMessage.set('Clasificación guardada exitosamente');

            this.classificationComplete.emit({
              id: alarm.id,
              status: alarm.status
            });

            // Restablecer el formulario sin emitir eventos
            this.classificationForm.reset({
              status: '',
              observations: ''
            }, { emitEvent: false });
          },
          error: (error) => {
            this.loading.set(false);
            this.errorMessage.set('Error al guardar la clasificación');
          },
        });


      this.closeDetails();
    } else {
      this.classificationForm.markAllAsTouched();
    }
  }



  closeDetails(): void {
    this.closed.emit();
  }

  onCancel() {
    // Restablecer el formulario sin emitir eventos
    this.classificationForm.reset({
      status: '',
      observations: ''
    }, { emitEvent: false });
  }
}
